import React from 'react';
import { Field } from 'redux-form';
import AddressSelectionForm from '../AddressSelectionForm/AddressSelectionForm';

interface Props {
    name: string;
    reduxForm: {
        name: string;
        change: Function;
        blur: Function;
    };
    addressFormTouched?: boolean;
    className?: string;
    addressFormClass?: string;
}

export function AddressSelectionFormAdapter(props: Props) {
    const { name, reduxForm } = props;
    return <Field name={`${reduxForm.name}.${name}`} component={AddressSelectionForm} props={props} />;
}
